module.exports = __webpack_public_path__ + "static/media/128.cfd32d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/128.jpg
// module id = 934
// module chunks = 0